const Forbidden = () => {
    return (
        <div className="text-center">
            <p className="fw-bold display-5">Oops!</p>
            <h5>You don't have access to page. Please contact administrator.</h5>
        </div>
    )

}

export default Forbidden;